import Breadcrumbs, { Slash } from "@insite/mobius/Breadcrumbs";
import Plus from "@insite/mobius/Icons/Plus";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@store/theme/design";
import { siteWidthStyles } from "@store/theme/mixins";
import { css } from "styled-components";

export default {
    defaultProps: {
        css: css`
            ${siteWidthStyles()}
            padding-top: 1.5em;
            margin-left: auto;
            margin-right: auto;
            flex-wrap: wrap;
            color: ${COLORS.primary.contrast};
            font-size: ${TYPOGRAPHY.size.smallest};
            span {
                text-decoration: underline;
                color: ${getColor("text.accent")};

                &:last-child {
                    text-decoration: none;
                }

                &:hover {
                    text-decoration: none;
                }

                > span {
                    /* Breadcrumbs links color override */
                    color: ${getColor("text.main")} !important;
                }
            }

            > span:last-child {
                font-weight: ${TYPOGRAPHY.weight.bold};
            }

            ${Slash} {
                position: relative;
                overflow: hidden;
                text-indent: -500px;
                width: 8px;

                &::before {
                    content: "";
                    display: block;
                    position: absolute;
                    top: 50%;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    margin-top: 1.5px;
                    width: 5px;
                    height: 1.5px;
                    border-radius: 2px;
                    transform: rotate(-225deg);
                    background: ${getColor("text.accent")};
                }

                &::after {
                    content: "";
                    display: block;
                    position: absolute;
                    top: 50%;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    margin-top: -1.5px;
                    width: 5px;
                    height: 1.5px;
                    border-radius: 2px;
                    transform: rotate(45deg);
                    background: ${getColor("text.accent")};
                }
            }
            @media print {
                display: none !important;
            }
        `,
    },
};
